<template>
  <b-navbar
    toggleable="lg"
    class="navbar navbar-expand-lg navbar-light navbar--custom"
  >
    <div class="container">
      <router-link class="navbar-brand" to="/">
        <img
          src="./../assets/images/logo-videomedi-white.png"
          alt="Logotipo do Videomedi"
        />
      </router-link>

      <b-navbar-toggle
        class="navbar-toggler"
        data-toggle="collapse"
        target="nav-collapse"
      >
        <div class="animated-icon">
          <span />
          <span />
          <span />
          <span />
        </div>
      </b-navbar-toggle>

      <b-collapse v-if="!currentUser.name" id="nav-collapse" is-nav>
        <b-navbar-nav class="navbar-nav ml-auto">
          <RouterLink to="/login">
            <Button variant="link" class="login-button mr-2">
              Entrar
            </Button>
          </RouterLink>

          <RouterLink to="/cadastrar">
            <Button class="create-account-button">
              Criar uma conta
            </Button>
          </RouterLink>
        </b-navbar-nav>
      </b-collapse>

      <b-collapse v-else id="nav-collapse" is-nav>
        <b-navbar-nav class="navbar-nav ml-auto">
          <b-nav-item
            class="nav-item"
            v-for="route in routes"
            :key="route.link"
          >
            <RouterLink class="nav-link" :to="route.link">
              {{ route.label }}
            </RouterLink>
          </b-nav-item>
          <ProfileDropdown
            :current-user="currentUser"
            :component-tag="this.$options._componentTag"
          />
        </b-navbar-nav>
      </b-collapse>
    </div>
  </b-navbar>
</template>

<script>
import { userComputed } from "./../state/helpers";
import ProfileDropdown from "../components/ProfileDropdown";
import { getTopbarRoutes } from "../utils/routes/routes";
import Button from "./Button.vue";
import { isDoctor } from "../utils/userRole";

export default {
  name: "AdminTopBar",
  components: {
    ProfileDropdown,
    Button
  },
  data() {
    return {
      routes: []
    };
  },
  mounted() {
    this.$data.routes = getTopbarRoutes(this.accountType);
  },
  computed: {
    ...userComputed,
    isDoctor() {
      return isDoctor(this.currentUser);
    },
    accountType() {
      return this.currentUser.account_type;
    }
  }
};
</script>

<style scoped>
.navbar {
  background: #d81a67 !important;
}
.nav-link {
  color: #fff !important;
}
.nav-link:active,
.nav-link:focus {
  color: #ffffff !important;
}
.animated-icon span {
  background-color: #fff !important;
}

.create-account-button {
  background-color: #ffffff !important;
  color: #d81a67 !important;
}

.login-button {
  color: #ffffff !important;
}
</style>
